import React from 'react'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { AppState } from '../../reducers'
import { SessionState } from '../../reducers/auth/session'
import { Typography } from '@mui/material'
import AdminWrapper from '../Administrator/AdminWrapper'
import ClientWrapper from '../Client/ClientWrapper'
import VendorWrapper from '../Vendor/VendorWrapper'
import { useThemeContext } from '../../theme/ThemeContext'
import { useTranslation } from "react-i18next";
import StaffWrapper from '../Staff/StaffWrapper'
import HeadSalesWrapper from '../HeadSales/HeadSalesWrapper'
import ManagerWrapper from '../Manager/ManagerWrapper'

interface Props {
  session?: SessionState
}

const UserData: React.FC<Props> = ({ session }) => {
  const { theme } = useThemeContext()
  const { t } = useTranslation(['header', 'client'])
  const location = useLocation()
  
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: 'flex-start', backgroundColor: theme.palette.info.main }}>
      <div style={{ display: "flex", flexDirection: "row", minWidth: "400px", justifyContent: 'space-between', alignItems: "center" }}>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Typography variant="h5" color="secondary">{t('hello')},&nbsp;</Typography>
          <Typography variant="h5" fontWeight='bold' color="primary">
            <AdminWrapper>{session?.fullName},&nbsp;{t('admin')}</AdminWrapper>
            <ClientWrapper>{session?.fullName}</ClientWrapper>
            <StaffWrapper>{session?.fullName},&nbsp;{t('staff')}</StaffWrapper>
            <HeadSalesWrapper>{session?.fullName},&nbsp;{t('headsales')}</HeadSalesWrapper>
            <ManagerWrapper>{session?.fullName},&nbsp;{t('manager')}</ManagerWrapper>
            <VendorWrapper>{session?.fullName},&nbsp;{t('vendor')}&nbsp;</VendorWrapper>
          </Typography>
        </div>
        <Typography variant="h5" color="primary">
          <ClientWrapper>&nbsp;{session?.clientName}</ClientWrapper>
        </Typography>
        {/*
        <div style={{ display: "flex", alignItems: "center", flexDirection: "row", margin: "10px" }}>
          <VendorWrapper>
          <FilterClientName label={t('title', { ns: 'client'})} role={VENDOR} roleId={session?.byPersonTypeId}/>
          </VendorWrapper>
        </div>*/}
      </div>
      <Typography variant="subtitle2">
        {location.state ? (location.state as any).title : ''}
      </Typography>

    </div>
  )
}

const mapStateToProps = (state: AppState) => ({
  session: state.session
})

export default connect(mapStateToProps, null)(UserData)
